module.exports = fox._r("fonts/icon-mc_other2.woff?ctdsoz", __webpack_public_path__ + "_/_/_/common/frame/fonts/luSVaZq.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/icon-mc_other2.woff?ctdsoz
// module id = 149
// module chunks = 2